import { Button, Form, message, Modal } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React from 'react'
import { environment } from '../../environments/environment';
import { utility } from '../../helpers/loader';
import { setPageLoader } from '../../redux/features/utils.slice';
import { routes } from '../../Services/api/routes';

const EmployeeDocumentDeleteModal = ({ open, close, employeeDetails, setFlag, flag }) => {

    const onFinish = async (values) => {
        try {
            utility?.dispatch(setPageLoader({ pageName: "main", flag: true }))
            let response = await fetch(`${environment.apiPaths.base}/${environment.apiPaths.router}${routes.employee.deleteDocument}?id=${employeeDetails?.ApplicantId ? employeeDetails?.ApplicantId : employeeDetails?.id}&name=${open?.name}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("access_jwt")
                },
                body: JSON.stringify(values)
            })
            utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
            if (response?.status === 200) {
                close()
                setFlag(!flag)
            } else {
                message.error(response?.statusText)
            }
        } catch (err) {
            utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
            console.log(err)
        }
    };
    return (
        <Modal
            open={open?.flag}
            onCancel={() => close()}
            footer={false}
            title={"Delete document"}
        >
            <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto", padding: "20px", border: "1px solid #f0f0f0", borderRadius: "8px" }}>
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Comment"
                        name="comment"
                        rules={[{ required: true, message: "Please enter your comment!" }]}
                    >
                        <TextArea rows={4} placeholder="Write your comment here..." maxLength={200} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" danger htmlType="submit" style={{ width: "100%" }}>
                            Delete document
                        </Button>
                    </Form.Item>
                </Form>
            </div>

        </Modal>
    )
}

export default EmployeeDocumentDeleteModal